import { render, staticRenderFns } from "./SIIconnect.vue?vue&type=template&id=15291a2b"
import script from "./SIIconnect.vue?vue&type=script&lang=js"
export * from "./SIIconnect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports